import axios from 'axios'
import router from '../router'
import {Message} from 'element-ui';
import ro from "element-ui/src/locale/lang/ro";

//1. 创建新的axios实例，
const service = axios.create({
  timeout: 60 * 1000// 超时时间
})

// 2.axios请求拦截器，before request
service.interceptors.request.use(config => {
  // config.data = JSON.stringify(config.data);
  // config.headers = {
  //   'Content-Type': 'application/json' //配置请求头
  // }
  const token = localStorage.token;
  if (token) {
    config.headers["x-own-token"] = token; //如果要求携带在请求头中
  }
  return config
}, error => {
  Promise.reject(error)
})

// 3.axios响应拦截器
service.interceptors.response.use(response => {
  //请求成功，返回data（需要更多信息return response）
  return response.data
}, error => {
  let errorMsg = null;
  if (error && error.response) {
    errorMsg = 'sorry , error：' + error.response.status
  } else {
    errorMsg = error.message
  }

  Message.error(errorMsg)
  if (error.response.status === 401) {
    console.log("#########"+this.router)
    localStorage.removeItem('alias')
    localStorage.removeItem('token')
    router.push("/")
  } else {
    return Promise.resolve(error.response)
  }
})
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js